module.exports = __webpack_public_path__ + "static/media/how_bg.58d864ec.vtt";